/** Public ClimatePlans web application version (release notes in changelogEntries). */
export const SOFTWARE_VERSION = '1.4.0';

export function formatSoftwareVersionLabel(): string {
  return `v${SOFTWARE_VERSION}`;
}
